
import auth from "./AuthAPI.js";
import * as APPCONFIG from "../config/app-config.js";
import Http from "./Http.js";

class ManageUserService {
 

  saveEmployee(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveEmployee`,
      data: JSON.stringify(form),
    });
  }     


  getAllEmployee(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAllEmployee`,
      data: JSON.stringify(form),
    });
  }


  getAdminloginValue(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getUserById`,
      data: JSON.stringify(form),
    });
  }

  editAdmin(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/editAdmin`,
      data: JSON.stringify(form),
    });
  }


  editUser(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/editUser`,
      data: JSON.stringify(form),
    });
  }




  
  deleteUser(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/deleteuser`,
      data: JSON.stringify(form),
    });
  }



  // ----dropdown data------


  
  getAllUserData(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAllUserData`,
      data: JSON.stringify(form),
    });
  }


  // -----used---upward------











  // deleteUser(form) {
  //   return auth({
  //     method: "post",
  //     headers: Http.AUTH_HEADERS(),
  //     url: `${APPCONFIG.API_URL}api/deleteuser`,
  //     data: JSON.stringify(form),
  //   });
  // }

  uploadPhoto(form) {
    return auth({
      method: "post",
      headers: Http.MULTIPART_HEADERS(),
      url: `${APPCONFIG.API_URL}api/imageUpload`,
      data: form,
    });
  }



 
savechat(form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/savechat`,
      data: JSON.stringify(form),
    });
  }





  getPropertyData(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getPropertyData`,
      data: JSON.stringify(form),
    });
  }

  getUserByArea(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getUserByArea`,
      data: JSON.stringify(form),
    });
  }


  getUserById (form) { 
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getUserById`,
      data: JSON.stringify(form),
    });
  }


  changeNotificationStatus (form) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/changeNotificationStatus`,
      data: JSON.stringify(form),
    });
  }


  getAllEmployeeWithoutUserType(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAllEmployeeWithoutUserType`,
      data: JSON.stringify(form),
    });
  }

  getAllUserForAdmin(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAllUserForAdmin`,
      data: JSON.stringify(form),
    });
  }

  

  CreateOwnerByAdmin(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/CreateOwnerByAdmin`,
      data: JSON.stringify(form),
    });
  }
 
  

  EditOwnerByAdmin(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/EditOwnerByAdmin`,
      data: JSON.stringify(form),
    });
  }


  getReport(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getReport`,
      data: JSON.stringify(form),
    });
  }

  checkSubscriptionStatus(form){
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/checkSubscriptionStatus`,
      data: JSON.stringify(form),
    });
  }
  
}

export default new ManageUserService();
